// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';
import Reflux from 'reflux';

import steleStore from '../stores/stele-store.js';
import optionStore from '../stores/option-store.js';

export default React.createClass({
	propTypes: {
		parts: React.PropTypes.array,
		name: React.PropTypes.string,
		needsOptionStore: React.PropTypes.bool
	},
	mixins: [
		Reflux.connect(optionStore, 'options'), // löst nur wenn nötig das Zeichnen aus, siehe shouldComponentUpdate()
		Reflux.connect(steleStore, 'data') // entspricht parameter von trigger() bei output: des stores
	],
	getDefaultProps: function() {
		return {
			needsOptionStore: false,
			// default
			parts: [
				//{className: 'slxstele-toolbar__zoom', onMouseDown: null, enabled: () => true},
				//{className: 'slxstele-toolbar__color', onMouseDown: null, enabled: () => true},
				//{className: 'slxstele-toolbar__rotate', onMouseDown: null, enabled: () => true},

				//{className: 'slxstele-configbar__rgbw', onMouseDown: null, enabled: () => true},
				//{className: 'slxstele-configbar__wege', onMouseDown: null, enabled: () => true},
				//{className: 'slxstele-configbar__aufnahme', onMouseDown: null, enabled: () => true},
				//{className: 'slxstele-configbar__twinspot', onMouseDown: null, enabled: () => false},
				//{className: 'slxstele-configbar__f500', onMouseDown: null, enabled: () => false},
				////{className: 'slxstele-configbar__f1000', onMouseDown: null, enabled: () => false},
					],
			name: 'configbar'
		};
	},
	getInitialState: function() {
		return {
			mouseDown: false
		};
	},
	//shouldComponentUpdate: function(nextProps, nextState) { // TODO fix this or simply move the dependency up to stele-store keeping only the commitTime as a property to decide
	//	return (!this.state.data || this.state.mouseDown !== nextState.mouseDown || this.state.data.commitTime !== nextState.data.commitTime ||
	//			(this.props.needsOptionStore &&	(this.state.options !== nextState.options || JSON.stringify(this.state.options) !== JSON.stringify(nextState.options)))
	//		);
	//},
	storeRef: function(i, ref) {
		/**Array.<HTMLElement>*/this.partRefs= this.partRefs || [];
		this.partRefs[i] = ref;
	},
	partMouseDown: function(i, ev) {
		this.setState({mouseDown: true});
		this.props.parts[i].onMouseDown(this.partRefs[i].getBoundingClientRect(), ev);
	},
	mouseUp: function(ev) {
		this.setState({mouseDown: false});
	},
	mouseLeave: function(ev) {
		this.setState({mouseDown: false});
	},
	mouseEnter: function(ev) {
		if(ev.which === 1) {
			this.setState({mouseDown: true});
		}
	},
	render: function() {
		let i = -1;
		const renderedParts = this.props.parts.map( _ => {
			i++;
			const enabled = ((this.state.data && _.enabled && _.enabled(this.state.data.commited, this.state.options)) || !_.enabled);
			if(_.imgURL)
				return (<div className={_.className}  key={'configbar-'+i}><img
											src={_.imgURL}
											ref={this.storeRef.bind(this, i)}
											className={_.className + (enabled ? '' : ' slxstele-configbar-disabled')}
											onMouseDown={_.onMouseDown && enabled ? this.partMouseDown.bind(this, i) : null}
						/>{_.content?_.content:''}</div>);
			else
				return (<span  key={'configbar-'+i}
											ref={this.storeRef.bind(this, i)}
											className={_.className + (enabled ? '' : ' slxstele-configbar-disabled')}
											onMouseDown={_.onMouseDown && enabled ? this.partMouseDown.bind(this, i) : null}
							>{_.content?_.content:''}</span>);
		});
		return (
				<div className={'slxstele-'+this.props.name+(this.state.mouseDown?' slxstele-configbar-dragging':'')}
						 onMouseUp={this.mouseUp}
						 onMouseLeave={this.mouseLeave}
						 onMouseEnter={this.mouseEnter}
						>
					{renderedParts}
				</div>
		);
	}
});

